export const OHL = {
    name: 'DV  147/1',
    voltage: '110',
    regionCode: 'BR',
    stanice: [{name: 'BOR 2', position: {lat: 44.0546, lng: 22.1234}}],
    stubovi: [
        { index: 1, name: 'P-07', lat: 44.0661 , lng: 22.1001, sys: 1, portal: true },
        { index: 2, name: '1', lat: 44.0662 , lng: 22.1008, sys: 1},
        { index: 3, name: '2', lat: 44.0658 , lng: 22.1029, sys: 1},
        { index: 4, name: '3', lat: 44.0645 , lng: 22.1065, sys: 1},
        { index: 5, name: '4', lat: 44.0639 , lng: 22.1084, sys: 1},
        { index: 6, name: '5', lat: 44.0628 , lng: 22.1117, sys: 1},
        { index: 7, name: '6', lat: 44.0622 , lng: 22.1136, sys: 1},
        { index: 8, name: '7', lat: 44.0614 , lng: 22.1159, sys: 1},
        { index: 9, name: '8', lat: 44.0594 , lng: 22.1175, sys: 1},
        { index: 10, name: '9', lat: 44.0577 , lng: 22.1189, sys: 1},
        { index: 11, name: '10', lat: 44.0561 , lng: 22.1203, sys: 1},
        { index: 12, name: '11', lat: 44.0545 , lng: 22.121, sys: 1},
        { index: 13, name: 'P-05', lat: 44.0542 , lng: 22.1221, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P-07 - 1', position: [{ lat: 44.0661 , lng: 22.1001 }, { lat: 44.0662 , lng: 22.1008 }] },
        { name: '1 - 2', position: [{ lat: 44.0662 , lng: 22.1008 }, { lat: 44.0658 , lng: 22.1029 }] },
        { name: '2 - 3', position: [{ lat: 44.0658 , lng: 22.1029 }, { lat: 44.0645 , lng: 22.1065 }] },
        { name: '3 - 4', position: [{ lat: 44.0645 , lng: 22.1065 }, { lat: 44.0639 , lng: 22.1084 }] },
        { name: '4 - 5', position: [{ lat: 44.0639 , lng: 22.1084 }, { lat: 44.0628 , lng: 22.1117 }] },
        { name: '5 - 6', position: [{ lat: 44.0628 , lng: 22.1117 }, { lat: 44.0622 , lng: 22.1136 }] },
        { name: '6 - 7', position: [{ lat: 44.0622 , lng: 22.1136 }, { lat: 44.0614 , lng: 22.1159 }] },
        { name: '7 - 8', position: [{ lat: 44.0614 , lng: 22.1159 }, { lat: 44.0594 , lng: 22.1175 }] },
        { name: '8 - 9', position: [{ lat: 44.0594 , lng: 22.1175 }, { lat: 44.0577 , lng: 22.1189 }] },
        { name: '9 - 10', position: [{ lat: 44.0577 , lng: 22.1189 }, { lat: 44.0561 , lng: 22.1203 }] },
        { name: '10 - 11', position: [{ lat: 44.0561 , lng: 22.1203 }, { lat: 44.0545 , lng: 22.121 }] },
        { name: '11 - P-05', position: [{ lat: 44.0545 , lng: 22.121 }, { lat: 44.0542 , lng: 22.1221 }] }
    ]
}
